import { Component, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { ButtonComponent, NotificationService, } from '@pansa/ui';
import { HelpService } from '../../services/help.service';
import { HelpDTO } from '../../model/help.model';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { QuillModule } from 'ngx-quill';

const locale = 'PL';


@Component({
  selector: 'rqa-help-polish',
  imports: [ButtonComponent, FormsModule, DatePipe, QuillModule],
  templateUrl: './help-polish.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})

export class HelpPolishComponent implements OnInit {
  private helpService = inject(HelpService);
  private notificationService = inject(NotificationService);
  help: HelpDTO = {
    content: '',
    contentForDraw: '',
    locale: locale,
    username: '',
    updated: new Date()
  };

  ngOnInit(): void {
    this.helpService.getHelp(locale).subscribe(
      (value) => {
        this.help = value;
      },
      () => {
        this.help.content = '';
        this.help.locale = locale;
      }
    );
  }

  save(): void{
    this.helpService.saveHelp(this.help).subscribe(res => {
      this.notificationService.success({title: 'Sukces', subTitle: 'Zaktualizowano zakładkę Pomoc'});
    });
  }
}
